import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { sendNotification } from "../api/plan";
import { SHOW_SNACKBAR } from "../utils/types";
import { generateTokenByApiKey } from "../api/login";
import { getEmailBody } from "../utils/helper";

const Contact = () => {
  const [notification, setNotification] = useState({});
  let dispatch = useDispatch();

  const onSendEmail = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = notification;
    const emailBody = getEmailBody(name, email, phone, message);

    if (!name || !email || !phone || !subject || !message) {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          type: "error",
          message: "Please fill all required fields",
          open: true,
        },
      });
      return;
    }

    const request = {
      notificationType: "EMAIL",
      from: process.env.REACT_APP_SENDER_EMAIL,
      subject: subject || "Contact Form Submission",
      toUsers: {
        [process.env.REACT_APP_TO_EMAIL]: {
          email: process.env.REACT_APP_TO_EMAIL
        }
      },
      body: emailBody
    };
    dispatch(
      generateTokenByApiKey(
        {},
        "zealthix",
        {
          "x-tenant-id": process.env.REACT_APP_TENANT_ID,
          "X-Api-Key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        (t) => {
          if (t.access_token) {
            dispatch(sendNotification(request, t.access_token, a => {
              e.target.reset();
              setNotification({});
              dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                  type: "error",
                  message: "Email sent successfully",
                  open: true,
                },
              });
            }))
          }
        }
      )
    );
  }


  return (
    <main>
      {/* Page Banner */}
      <div className="page-banner overlay">
        <picture className="media media-bg max-md:!hidden">
          <img
            src="assets/img/banner/page-banner.jpg"
            width={1920}
            height={520}
            loading="eager"
            alt="Page Banner Image"
          />
        </picture>
        <div className="page-banner-content">
          <div className="container text-center">
            <h1 className="heading text-80 fw-700 max-md:!text-[30px]">
              Contact Us
            </h1>
            <ul
              className="breadcrumb list-unstyled"
            >
              <li>
                <a
                  href="/"
                  className="text text-18"
                  aria-label="Home Page"
                >
                  Home
                </a>
              </li>
              <li>
                <svg
                  width={8}
                  height={12}
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.08929 5.40903C7.24552 5.5653 7.33328 5.77723 7.33328 5.9982C7.33328 6.21917 7.24552 6.43109 7.08929 6.58736L2.37512 11.3015C2.29825 11.3811 2.2063 11.4446 2.10463 11.4883C2.00296 11.532 1.89361 11.5549 1.78296 11.5559C1.67231 11.5569 1.56258 11.5358 1.46016 11.4939C1.35775 11.452 1.2647 11.3901 1.18646 11.3119C1.10822 11.2336 1.04634 11.1406 1.00444 11.0382C0.962537 10.9357 0.941453 10.826 0.942414 10.7154C0.943376 10.6047 0.966364 10.4954 1.01004 10.3937C1.05371 10.292 1.1172 10.2001 1.19679 10.1232L5.32179 5.9982L1.19679 1.8732C1.04499 1.71603 0.960996 1.50553 0.962894 1.28703C0.964793 1.06853 1.05243 0.859522 1.20694 0.705015C1.36145 0.550508 1.57046 0.462868 1.78896 0.460969C2.00745 0.45907 2.21795 0.543066 2.37512 0.694864L7.08929 5.40903Z"
                    fill="currentColor"
                  />
                </svg>
              </li>
              <li>
                <a role="link" aria-disabled="true" className="text text-18 active">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <div className="section-contact-form section-padding">
        <div className="container">
          <div className="contact-box radius18">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="!w-full col-span-2 col-contact-content">
                <div className="section-headings">
                  <div className="flex flex-col max-md:items-center">
                    <div
                    className="subheading text-20 subheading-bg w-fit"
                  >
                    <svg
                      className="icon icon-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_9088_4143)">
                        <path
                          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                          fill="CurrentColor"
                        />
                      </g>
                      <defs>
                        <clipPath>
                          <rect width={14} height={14} fill="CurrentColor" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>Contact Us</span>
                    <svg
                      className="icon icon-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_9088_4143)">
                        <path
                          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
                          fill="CurrentColor"
                        />
                      </g>
                      <defs>
                        <clipPath>
                          <rect width={14} height={14} fill="CurrentColor" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <h2 className="heading text-50 max-md:text-center">
                    Let’s Start a Conversation
                  </h2>
                  </div>
                  <section className="py-8 bg-gray-50 mt-[40px] rounded-[8px] max-md:py-2">
                    <div className="max-w-6xl mx-auto px-8 max-md:px-2">
                      {/* Contact Cards (Flex) */}
                      <div className="flex gap-6 justify-center max-md:flex-col max-md:gap-2">
                        {/* Address */}
                        <div className="w-full  bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition">
                          <div className="flex items-start gap-4">
                            <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-blue-100 text-[#0657a3]">
                              <i className="fa-solid fa-location-dot text-lg" />
                            </div>
                            <div>
                              <h3 className="text-lg font-semibold text-gray-800">Address</h3>
                              <p className="text-gray-600 text-[16px] mt-1 leading-relaxed">
                                LG32 - A, Bansi Trade Center 581/5 M G Road - Indore (M.P.) 452001
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col gap-6 max-md:gap-2">
                          {/* Phone */}
                          <div className="w-full bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition">
                            <div className="flex items-start gap-4">
                              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-blue-100 text-[#0657a3]">
                                <i className="fa-solid fa-phone text-lg" />
                              </div>
                              <div>
                                <h3 className="text-lg font-semibold text-gray-800">Phone</h3>
                                <p className="text-gray-600 text-[16px] mt-1">
                                  <a
                                    href="tel:+91 9826533389"
                                    className="hover:text-[#0657a3] transition"
                                  >
                                    +91 9826533389
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* Email */}
                          <div className="w-full bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition">
                            <div className="flex items-start gap-4">
                              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-blue-100 text-[#0657a3]">
                                <i className="fa-solid fa-envelope text-lg" />
                              </div>
                              <div>
                                <h3 className="text-lg font-semibold text-gray-800">Email</h3>
                                <p className="text-gray-600 text-[16px] mt-1">
                                  <a
                                    href="mailto:care@aarogyaopd.com"
                                    className="hover:text-[#0657a3] transition"
                                  >
                                    care@aarogyaopd.com
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact;
